let Options = {
  breakpoint: { pc: 1200, tb: 992, sp: 768, ss: 576, min: 375 },
  headId        : 'js-header',
  footId        : 'js-footer',

  loaded:       'is-loaded',
  scrollLock: 'is-scrollLock',
  act: 'is-act',
  inact: 'is-inact',
  actView: 'is-view',
  actOpen: 'is-open',
}

Options.shiftPoint = Options.breakpoint.tb;

export {Options};